<template>
    <div>
        <el-table :data="list" v-loading="loading">
            <template #empty="scope">
                <el-empty :description="i18n.tkey('lang_temporary_no_data')">

                </el-empty>
            </template>

            <el-table-column :label="i18n.tkey('lang_company_name')" >
                <template #default="scope">
                    <div style="">
                        <span>{{ scope.row.company.companyname }}</span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column :label="i18n.tkey('lang_company_email')" >
                <template #default="scope">
                    <div style="">
                        <span>{{ scope.row.company.email }}</span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column :label="i18n.tkey('lang_doornum_text')" >
                <template #default="scope">
                    <div style="">
                        <span>{{ scope.row.addinfo1 }} - {{ scope.row.addinfo2 }}</span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="date" :label="i18n.tkey('lang_operate')" >
                <template #default="scope">
                    <div style="">
                        <el-text
                            type="success"
                            v-if="scope.row.recordno == 0"
                            @click="clickApproved(scope.row)"
                            tkey="通過審核"
                        >
                            {{i18n.tkey("lang_approved")}}
                        </el-text>
                        &nbsp;
                        <el-text
                            type="primary"
                            v-if="scope.row.recordno == -1"
                            @click="clickEdit(scope.row)"
                            tkey="編輯"
                        >
                            {{i18n.tkey("lang_modify")}}
                        </el-text>
                        &nbsp;
                        <el-text
                            type="danger"
                            @click="clickDelBtn(scope.row.id)"
                        >
                            {{i18n.tkey("lang_delete")}}
                        </el-text>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script setup>

import {inject, ref} from "vue";
import myUtil from "@/util/util";
import record15Api from "@/request/record15Api";

const props = defineProps(["list"])
const emits = defineEmits(["save-success", "del-success", "clickEdit"])

const i18n = inject("i18n")
const loading = ref(false)

function clickDelBtn(id){
    myUtil.confirmWarning(i18n.tkey("lang_delete_confirm"), () => {
        delRecord15(id)
    })
}

function delRecord15(id){
    loading.value = true

    const request = record15Api.delAdditionalrecord15
    const params = request.getParams()

    params.id = id

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_delete_success"))
            emits("del-success")
        }else{
            myUtil.alertError(res.msg)
        }

    })

}

function approvedRecord(obj){
    loading.value = true

    const request = record15Api.updateRecordStats
    const params = request.getParams()

    params.id = obj.id
    params.recordno = -1

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_save_success"))
            emits("save-success")
        }else{
            myUtil.alertError(res.msg)
        }
    })

}

function clickApproved(obj){
    myUtil.confirmWarning(i18n.tkey("lang_approved_confirm"), () => {
        approvedRecord(obj)
    })
}

function clickEdit(obj){
    emits("clickEdit", obj)
}

</script>

<style scoped>

</style>